import { useContext } from "react";
import { UserDataContext } from "../providers/UserDataProvider";

export default function useUserData() {
  const contextValue = useContext(UserDataContext);
  return contextValue;
}